<template>
	<v-list-group
		v-if="item.subitems"
		:active-class="activeClass"
		:sub-group="depth > 0"
		:class="getClass"
		:value="item.expand"
	>
		<v-list-item slot="activator">
			<v-list-item-action>
				<v-icon>{{ item.icon }}</v-icon>
			</v-list-item-action>
			<v-list-item-title>{{ item.title }}</v-list-item-title>
			<v-list-item-action v-if="depth > 0" class="v-list__group__header__append-icon">
				<v-icon>mdi-menu-down</v-icon>
			</v-list-item-action>
		</v-list-item>

		<template v-for="(subitem,i) in item.subitems">
			<app-drawer-item :key="i" :item="subitem" :depth="depth+1"></app-drawer-item>
		</template>
	</v-list-group>

	<v-list-item
		v-else
		:class="getClass"
		:to="item.link"
		:target="item.target"
		:value="item.expand"
		:active-class="activeClass"
		exact
	>
		<v-list-item-action>
			<v-icon>{{ item.icon }}</v-icon>
		</v-list-item-action>
		<v-list-item-title>{{ item.title }}</v-list-item-title>
	</v-list-item>
</template>

<script>
export default {
	name: "AppDrawerItem",
	props: {
		item: {
			type: Object,
			required: true
		},
		depth: {
			type: Number,
			default: 0
		},
		activeClass: {
			type: String,
			default: "red--text"
		}
	},
	computed: {
		getClass() {
			switch (this.depth) {
			case 0:
				return "drawer1";
			case 1:
				return "drawer2";
			case 2:
				return "drawer3";
			case 3:
				return "drawer4";
			}
			return "drawer4";
		}
	}
};
</script>
